/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */

Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.MappedData = (function () {
  function MappedData() {
    Monet.UI.Fields.Base.apply(this, arguments);
    this.createBaseStructure();

    this.container = null;
    this.data = [];
    var listItems = [];
    var fields = {
      leftField: null,
      fieldRight: null,
    };

    this.setFields = function (fieldsObject) {
      fields = fieldsObject;
    };

    this.setValue = function (data) {
      this.data = data;
      this.update();
    }

    this.addItemToList = function (element, fieldLeft, fieldRight) {
      listItems.push({ element, fieldLeft, fieldRight });
    };

    this.getListItem = function () {
      return listItems;
    }

    this.removeItem = function (rangeId) {
      for (var i = 0; i < listItems.length; i++) {
        const { element } = listItems[i];
        if (element.id === rangeId) {
          this.container.removeChild(element);
          listItems.splice(i, 1);
          return;
        }
      }
    };

    this.createElement = function (data, enableRemoveItem) {
      var containerFields = document.createElement('div');
      if (enableRemoveItem) {
        fields.fieldLeft.label = '';
        fields.fieldRight.label = '';
      }
      fields.fieldLeft.name = `${fields.fieldLeft.name}_${listItems.length}`
      fields.fieldRight.name = `${fields.fieldRight.name}_${listItems.length}`
      var fieldLeft = new Monet.UI.Fields.Render(fields.fieldLeft).render();
      var fieldRight = new Monet.UI.Fields.Render(fields.fieldRight).render();
      var symbolPlus = document.createElement('span');

      containerFields.id = Date.now();
      containerFields.setAttribute('class', 'mappeddata__item');

      if (data) {
        fieldLeft.setValue(data.fieldLeft);
        fieldRight.setValue(data.fieldRight);
      }

      symbolPlus.setAttribute('class', 'buttonAdd');
      symbolPlus.onclick = function () {
        this.container.appendChild(this.createElement(null, true));
      }.bind(this);

      symbolPlus.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey('ipRangeProfile.plus'));

      containerFields.appendChild(fieldLeft.rootEl);
      containerFields.appendChild(fieldRight.rootEl);

      if (enableRemoveItem) {
        var symbolNegative = document.createElement('span');
        symbolNegative.setAttribute('class', 'buttonRemove');
        symbolNegative.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey('ipRangeProfile.remove'));
        symbolNegative.onclick = function () {
          this.removeItem(containerFields.id);
        }.bind(this);
        containerFields.appendChild(symbolNegative);
      }

      containerFields.appendChild(symbolPlus);
      this.addItemToList(containerFields, fieldLeft, fieldRight);
      return containerFields;
    };

    this.createElements = function () {
      const list = document.createDocumentFragment();
      this.data.forEach(function(item, index) {
        list.appendChild(this.createElement(item, index));
      }.bind(this));
      return list;
    }

    this.update = function () {
      this.rootEl.removeChild(this.rootEl.querySelector('.mappeddata_container'));
      listItems = [];
      this.render();
    }

    this.renderContainer = function () {
      this.container = document.createElement('div');
      this.container.setAttribute('class', 'mappeddata_container');
      if (this.data && this.data.length === 0) {
        this.container.appendChild(this.createElement());
      } else {
        this.container.appendChild(this.createElements());
      }
    }

    this.render = function () {
      this.renderContainer();
      this.rootEl.appendChild(this.container);
      return this.rootEl;
    };
  }

  return MappedData;
})();
